<div>
    <mat-card appearance="raised">
      <mat-card-title style="text-align: center;">Usage Statistics</mat-card-title>
      <mat-card-content>
        <div class="flex-container">
            <div class="flex-item">
                <h2>Daily Logins</h2>
                <table>
                    <th>Day</th><th>Date</th><th>Logins</th><th>Unique</th>
                    @for (ld of loginDays; track $index) {
                        <tr>
                            <td>{{ld.dayName}}</td>
                            <td style="width: 12em">{{ld.loginDate}}</td>
                            <td>{{ld.totalLogins}}</td>
                            <td>{{ld.uniqueLogins}}</td>
                        </tr>
                    }
                </table>
            </div>
            <div class="flex-item">
                <div>
                    <h2>Whose Online</h2>
                    <table>
                        <thead>
                            <th>User</th><th>Organisation</th><th>Logged In</th><th>Last Action</th>
                        </thead>
                        @for (w of whoseOnline; track $index) {
                            <tr>
                                <td>{{w.email}}</td>
                                <td>{{w.organisation}}</td>
                                <td>{{ w.loggedIn ? (w.loggedIn * 1000 | date:'HH:mm') : '' }}</td>
                                <td>{{ w.lastAction ? (w.lastAction * 1000 | date:'HH:mm') : '' }}</td>
                            </tr>
                        }
                    </table>
                </div>                
                <div style="margin-top:20px">
                    <h2>Device Types This Month</h2>
                    <table>
                    <thead>
                        <tr>
                        <th>Operating System</th>
                        @for (device of deviceTypes; track $index) {
                            <th>{{ device }}</th>
                        }
                        
                        </tr>
                    </thead>
                    <tbody>
                        @for (os of operatingSystems; track $index) {
                            <tr>
                                <td>{{ os }}</td>
                                @for (device of deviceTypes; track $index) {
                                    <td style="text-align: center;">{{ tableData[os][device] }}</td>                                
                                }
                            </tr>
                        }
                    </tbody>                        
                    </table>
                </div>
            </div>
        </div>
      </mat-card-content>
    </mat-card>
</div>
